import { createSelector } from '@ngrx/store';

import { isOrderTypeValid } from '../../orderTypes/isOrderTypeValid';
import { getOnlineOrderState } from '../../../onlineOrder/selectors/getOnlineOrderState';
import { hasMetMinimumOrderValueCriteria } from '../../../onlineOrder/selectors/hasMetMinimumOrderValueCriteria';

export const isPaymentDisabledForOnlineOrderValidation = createSelector(
    getOnlineOrderState,
    isOrderTypeValid,
    hasMetMinimumOrderValueCriteria,
    (orderState, isValidOrderType, orderValueValid) =>
        orderState.updateRequest.isUpdating ||
        orderState.downloadRequest.isDownloading ||
        orderState.createRequest.isCreating ||
        orderState.recalculateRequest.isRecalculating ||
        !isValidOrderType ||
        orderValueValid === false,
);
